import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimInvoice.Save.IRequest;
type Response = Api.Core.ClaimInvoice.Save.IResponse;
type Headers = Api.Core.ClaimInvoice.Save.IHeaders;
const url = '/api/Claims/Claim/:id/Invoices';
export default async function claimInvoiceSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { id: body?.claimId }),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
